import { GetterTree } from 'vuex';
import { format } from 'date-fns';
import { JobState } from './state';

export const getters: GetterTree<JobState, any> = {
  formattedStartDate(state): string {
    if (!state.startDate) return '';
    return format(new Date(state.startDate), 'eeee, MMMM d, yyyy');
  },
  reservationFromQueryParam(state): string | null {
    return state.reservationId;
  },
  getLanguages(state): Array<string> {
    return state.languages;
  },
};

export default getters;
